import React, { useState } from 'react';
import Sidebar from '../Sidebar';
import { useAuthContext } from '../../contexts/AuthContext';
import './AppLayout.css';
import PageTransition from './PageTransition';

const AppLayout = ({ children }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const { user, handleLogout } = useAuthContext();

  const handleToggleSidebar = () => {
    setIsSidebarCollapsed(prev => !prev);
  };

  return (
    <div className="app-layout">
      <Sidebar 
        user={user}
        onLogout={handleLogout}
        isCollapsed={isSidebarCollapsed}
        onToggle={handleToggleSidebar}
      />
      <main className={`main-content ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        <PageTransition>{children}</PageTransition>
      </main>
    </div>
  );
};

export default AppLayout;
